import IconCard from "./icon-card";

export { IconCard };
